'use strict';

const jQuery = require('jquery');
const ContentManager = require('./../component/ContentManager');
const SaveManager = require('./../component/SaveManager');

const calculatePosition = function($container) {
    let containerWidth = $container.outerWidth();
    let containerHeight = $container.outerHeight();
    let $image = $container.find('img:not(.image-picto)');
    let imageWidth = $image.outerWidth();
    let imageHeight = $image.outerHeight();
    let focus = $container.data('focus') || {'top': 50, 'left': 50};
    let offsetX = -1 * ((imageWidth - containerWidth) * focus.left /100) * 100 / containerWidth;
    let offsetY = -1 * ((imageHeight - containerHeight) * focus.top /100) * 100 / containerHeight;

    return {'left': offsetX, 'top': offsetY};
};

const isAutoWidth = function(content) {
    let imageContainer = content.$;
    let image = imageContainer.find('img:not(.image-picto)');
    let containerHeight = imageContainer.outerHeight();
    let containerWidth = imageContainer.outerWidth();
    let imageRealWidth = image.get(0).naturalWidth;
    let imageRealHeight = image.get(0).naturalHeight;
    let autoWidth = imageContainer.data('auto-width') && containerWidth * imageRealHeight / imageRealWidth > containerHeight;

    return autoWidth;
};

const isAutoHeight = function(content) {
    return !isAutoWidth(content);
};

module.exports.applyAutoHeight = function(content) {
    content.$[isAutoHeight(content) ? 'addClass' : 'removeClass']('image-auto-height');
};

module.exports.applyAutoWidth = function(content) {
    content.$[isAutoWidth(content) ? 'addClass' : 'removeClass']('image-auto-width');
};

const applyWidth = function(content) {
    let autoWidth = isAutoWidth(content);
    let image = content.$.find('img:not(.image-picto)');
    let imageRealWidth = image.get(0).naturalWidth;
    let imageRealHeight = image.get(0).naturalHeight;
    let imageWidth = imageRealWidth/imageRealHeight * content.$.outerHeight();
    let imageWidthPercent;

    if (!autoWidth) {
        imageWidthPercent = imageWidth * 100 / content.$.outerWidth();
        content.$.find('img:not(.image-picto)').css('width', imageWidthPercent + '%');
        content.addParameter('width', imageWidthPercent.toString());
    } else {
        content.$.find('img:not(.image-picto)').css('width', '');
        content.addParameter('width', null);
    }
};

const applyPosition = function(content) {
    let imageContainer = content.$;
    let heightAuto = isAutoHeight(content);

    let position = calculatePosition(imageContainer);
    let offsetX = position.left;
    let offsetY = position.top > 0 ? 0 : position.top;

    if (heightAuto) {
        imageContainer.find('img:not(.image-picto)').css('left', offsetX + '%');
        imageContainer.find('img:not(.image-picto)').css('top', 0);
        imageContainer.data('position', {'left': offsetX, 'top': 0});
    } else {
        if (imageContainer.find('img:not(.image-picto)').outerWidth() > imageContainer.outerWidth()) {
            offsetX = offsetX > 0 ? 0 : offsetX;
        }
        imageContainer.find('img:not(.image-picto)').css('left', offsetX + '%');
        imageContainer.find('img:not(.image-picto)').css('top', offsetY + '%');
        imageContainer.data('position', {'left': offsetX, 'top': offsetY});
    }
};

const checkCrop = function() {
    jQuery('.media-image:not(.cloud-logo)').each(function() {
        if(jQuery(this).data('reset-position') !== undefined) {
            let content = ContentManager.getContentByNode(jQuery(this));
            let stretch = Boolean(content.$.data('auto-width'));

            applyPosition(content);
            content.addParameter('stretch_state', stretch);
            SaveManager.save();
        }
    });
};

module.exports.refresh = function(content) {
    if (content.$ && content.$.find('img:not(.image-picto)').length) {
        applyWidth(content);
        applyPosition(content);
        checkCrop();
    }
};

module.exports.applyPosition = applyPosition;
module.exports.checkCrop = checkCrop;
module.exports.isAutoWidth = isAutoWidth;
module.exports.isAutoHeight = isAutoHeight;
module.exports.applyWidth = applyWidth;
module.exports.calculatePosition = calculatePosition;
